
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// 烟花效果组件
function FireworksEffect() {
  const [fireworks, setFireworks] = useState<Array<{ id: number; x: number; y: number; color: string; delay: number }>>([]);

  useEffect(() => {
    const colors = ['#FFD700', '#FF6B6B', '#4ECDC4', '#FF69B4', '#FFA500', '#00CED1', '#FFFF00'];
    
    const generateFireworks = () => {
      const newFireworks = Array.from({ length: 6 }, (_, i) => ({
        id: Date.now() + i,
        x: Math.random() * 90 + 5,
        y: Math.random() * 50 + 20,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 1.5
      }));
      setFireworks(newFireworks);
    };

    generateFireworks();
    const interval = setInterval(generateFireworks, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {fireworks.map((fw) => (
          <div
            key={fw.id}
            className="absolute"
            style={{
              left: `${fw.x}%`,
              top: `${fw.y}%`,
            }}
          >
            {/* 烟花爆炸粒子 */}
            {Array.from({ length: 12 }).map((_, i) => (
              <span
                key={i}
                className="absolute w-1.5 h-1.5 rounded-full"
                style={{
                  backgroundColor: fw.color,
                  boxShadow: `0 0 4px ${fw.color}, 0 0 8px ${fw.color}`,
                  animation: `particle-${i} 1.2s ease-out ${fw.delay}s forwards`,
                  opacity: 0
                }}
              />
            ))}
            {/* 中心闪光 */}
            <span
              className="absolute w-2 h-2 rounded-full"
              style={{
                backgroundColor: '#fff',
                boxShadow: `0 0 8px #fff, 0 0 16px ${fw.color}`,
                left: '-4px',
                top: '-4px',
                animation: `flash 0.5s ease-out ${fw.delay}s forwards`,
                opacity: 0
              }}
            />
          </div>
        ))}
      </div>
      
      <style>{`
        @keyframes particle-0 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(0, -30px); opacity: 0; } }
        @keyframes particle-1 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(15px, -26px); opacity: 0; } }
        @keyframes particle-2 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(26px, -15px); opacity: 0; } }
        @keyframes particle-3 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(30px, 0); opacity: 0; } }
        @keyframes particle-4 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(26px, 15px); opacity: 0; } }
        @keyframes particle-5 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(15px, 26px); opacity: 0; } }
        @keyframes particle-6 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(0, 30px); opacity: 0; } }
        @keyframes particle-7 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(-15px, 26px); opacity: 0; } }
        @keyframes particle-8 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(-26px, 15px); opacity: 0; } }
        @keyframes particle-9 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(-30px, 0); opacity: 0; } }
        @keyframes particle-10 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(-26px, -15px); opacity: 0; } }
        @keyframes particle-11 { 0% { transform: translate(0, 0); opacity: 1; } 100% { transform: translate(-15px, -26px); opacity: 0; } }
        @keyframes flash { 0% { transform: scale(0); opacity: 1; } 50% { transform: scale(2.5); opacity: 0.9; } 100% { transform: scale(0); opacity: 0; } }
      `}</style>
    </>
  );
}

export default function Services() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const services = [
    {
      icon: 'ri-file-pdf-2-line',
      title: 'Adobe PDF Library SDK',
      description: '业界领先的PDF处理开发工具包，支持创建、编辑、转换和优化PDF文档，提供完整的API接口和跨平台支持',
      link: '/adobe-pdf-library',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: 'ri-exchange-line',
      title: 'Adobe PDF Converter',
      description: '高性能文档格式转换工具，支持PDF与Word、Excel、图片等多种格式互转，保持原始格式和布局',
      link: '/adobe-pdf-converter',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      icon: 'ri-cloud-line',
      title: 'pdfRest API Toolkit',
      description: '基于容器化的PDF处理REST API工具包，提供完整的PDF操作接口，支持快速部署和灵活集成',
      link: '/pdf-rest-container',
      color: 'from-blue-500 to-teal-500'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'PDF Forms Extension SDK',
      description: '专业的PDF表单扩展开发工具，支持创建交互式表单、数据提取和自动化填充，提升表单处理效率',
      link: '/pdf-forms-extension-sdk',
      color: 'from-teal-400 to-emerald-500'
    },
    {
      icon: 'ri-layout-masonry-line',
      title: 'Adobe InDesign Server',
      description: '企业级自动化排版引擎，支持批量文档生成、模板驱动设计和高质量印刷输出，实现设计流程自动化',
      link: '/products',
      color: 'from-rose-500 to-orange-500'
    }
  ];

  const totalSlides = Math.ceil(services.length / 3);
  
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50" aria-labelledby="services-heading">
      {/* 新年祝福横幅 */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12">
        <div className="relative overflow-hidden bg-gradient-to-r from-red-600 via-red-500 to-red-600 rounded-2xl shadow-lg">
          {/* 烟花效果 */}
          <FireworksEffect />
          {/* 装饰元素 */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-2 left-8 text-4xl">🧧</div>
            <div className="absolute top-2 right-8 text-4xl">🧧</div>
            <div className="absolute bottom-2 left-1/4 text-3xl">✨</div>
            <div className="absolute bottom-2 right-1/4 text-3xl">✨</div>
          </div>
          {/* 金色边框装饰 */}
          <div className="absolute inset-0 border-4 border-yellow-400/30 rounded-2xl pointer-events-none"></div>
          {/* 主内容 */}
          <div className="relative py-6 px-8 text-center z-10">
            <div className="flex items-center justify-center gap-4">
              <span className="text-3xl">🐴</span>
              <p className="text-xl md:text-2xl lg:text-3xl font-bold text-white tracking-wider" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
                <span className="text-yellow-300">星允信息</span>祝大家2026年马年大吉！
              </p>
              <span className="text-3xl">🐴</span>
            </div>
            <div className="mt-2 flex items-center justify-center gap-2">
              <span className="text-yellow-300 text-sm">🎊 万事如意 🎊 财源广进 🎊 事业腾飞 🎊</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 id="services-heading" className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>核心产品与服务</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            为企业提供全方位的<strong>PDF处理解决方案</strong>，助力<strong>文档数字化转型</strong>
          </p>
        </header>

        <div className="relative">
          {/* Slider Container */}
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div key={slideIndex} className="w-full flex-shrink-0">
                  <div className="grid md:grid-cols-3 gap-8">
                    {services.slice(slideIndex * 3, slideIndex * 3 + 3).map((service, index) => (
                      <article 
                        key={index}
                        className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
                      >
                        <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.color} mb-6`}>
                          <i className={`${service.icon} text-3xl text-white`} aria-hidden="true"></i>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">
                          <strong>{service.title}</strong>
                        </h3>
                        <p className="text-gray-600 mb-6 leading-relaxed">
                          {service.description}
                        </p>
                        <Link 
                          to={service.link}
                          className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold cursor-pointer"
                          aria-label={`了解更多关于${service.title}`}
                        >
                          了解更多
                          <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
                        </Link>
                      </article>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-12 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer z-10"
            aria-label="上一页"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-12 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer z-10"
            aria-label="下一页"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-10 gap-3">
            {Array.from({ length: totalSlides }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  currentSlide === index 
                    ? 'bg-teal-500 w-8' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`切换到第${index + 1}页`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
